/* Aico Faq - toggles .active on each accordion item; height animates via CSS (grid-rows) */
(function () {
  'use strict';

  function initFaq(root) {
    if (!root || root.dataset.faqInit === '1') return;
    root.dataset.faqInit = '1';

    root.querySelectorAll('[data-faq-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.aico-faq__item');
        if (!item) return;
        var open = item.classList.toggle('active');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-aico-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-aico-faq]') : null;
    if (el) initFaq(el);
  });
})();
